/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import { Api } from '@/services/Api'

export default {
  getCompPostions(plantId) {
    return Api().get(`/api/v1.0/plantOverview/config/${plantId}`)
  },
  blockGeneration (plantId, startDate, endDate) {
    return Api().get(`/api/v1.0/blockGeneration/${plantId}/${startDate}/${endDate}`)
  },
  plantCoordinates (plantId, startDate, endDate) {
    return Api().get(`/api/v1.0/plantCoordinates/${plantId}/${startDate}/${endDate}`)
  },
  getInverterRoomGeneration (plantId, startDate, endDate) {
    return Api().get(`/api/v1.0/inverterRoomGeneration/${plantId}/${startDate}/${endDate}`)
  },
  getInverterGeneration (plantId, startDate, endDate) {
    return Api().get(`/api/v1.0/inverterGeneration/${plantId}/${startDate}/${endDate}`)
  },
  getScbCurrent (plantId, startDate, endDate) {
    return Api().get(`/api/v1.0/scbCurrent/${plantId}/${startDate}/${endDate}`)
  },
  gotoSunny (email, password) {
    return Api().post('http://testforecast.avisolar.com/Login/login_validation', {
      email,
      password
    })
  },
  // NEW API's
  getCardBlock(plantId, blockId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/card/block/${plantId}/${blockId}/${dateFrom}/${dateTo}`)
  },

  getCardPlant(plantId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/card/plant/${plantId}/${dateFrom}/${dateTo}`)
  },

  // KPI Metrics
  getKpiPlant(plantId, date) {
    return Api().get(`/api/v1.0/plantOverview/table/plant/${plantId}/${date}`)
  },
  getKpiBlock(plantId, blockId, date) {
    return Api().get(`/api/v1.0/plantOverview/table/block/${plantId}/${blockId}/${date}`)
  },
  // GRAPH DATA
  getGraphPlant(plantId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/graph/${plantId}/${dateFrom}/${dateTo}`)
  },
  sendGraphToPop(param) {
    return Api().post(`api/v1.0/plantOverview/graph/parameter`, param)
  },
  getRadialBlock(plantId, blockId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/radial/block/${plantId}/${blockId}/${dateFrom}/${dateTo}`)
  },

  getRadialPlant(plantId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/radial/plant/${plantId}/${dateFrom}/${dateTo}`)
  },
  getWidgetBlock(plantId, blockId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/widget/block/${plantId}/${blockId}/${dateFrom}/${dateTo}`)
  },

  getWidgetPlant(plantId, dateFrom, dateTo) {
    return Api().get(`/api/v1.0/plantOverview/widget/plant/${plantId}/${dateFrom}/${dateTo}`)
  },
  getManualAlert(plantId) {
    return Api().get(`/api/v2/alert/manual-alert/${plantId}/computed/MA/poo`)
  }
}
